import React, { Component } from 'react';
import SobreNos from '../../Components/SobreNos';

class Sobre extends Component {
    render() {
        return (
            <div className="div-sobre">
                <SobreNos>
                </SobreNos>
            </div>
        )
    }
}

export default Sobre;
